import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledCRMListContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 8px;
    background: ${colorsPalettes.carbon[0]};
    margin-top: 24px;
    border-radius: 6px;
`;
